import './regular/address-book'
import './regular/address-card'
import './regular/angry'
import './regular/arrow-alt-circle-down'
import './regular/arrow-alt-circle-left'
import './regular/arrow-alt-circle-right'
import './regular/arrow-alt-circle-up'
import './regular/bell-slash'
import './regular/bell'
import './regular/bookmark'
import './regular/building'
import './regular/calendar-alt'
import './regular/calendar-check'
import './regular/calendar-minus'
import './regular/calendar-plus'
import './regular/calendar-times'
import './regular/calendar'
import './regular/caret-square-down'
import './regular/caret-square-left'
import './regular/caret-square-right'
import './regular/caret-square-up'
import './regular/chart-bar'
import './regular/check-circle'
import './regular/check-square'
import './regular/circle'
import './regular/clipboard'
import './regular/clock'
import './regular/clone'
import './regular/closed-captioning'
import './regular/comment-alt'
import './regular/comment-dots'
import './regular/comment'
import './regular/comments'
import './regular/compass'
import './regular/copy'
import './regular/copyright'
import './regular/credit-card'
import './regular/dizzy'
import './regular/dot-circle'
import './regular/edit'
import './regular/envelope-open'
import './regular/envelope'
import './regular/eye-slash'
import './regular/eye'
import './regular/file-alt'
import './regular/file-archive'
import './regular/file-audio'
import './regular/file-code'
import './regular/file-excel'
import './regular/file-image'
import './regular/file-pdf'
import './regular/file-powerpoint'
import './regular/file-video'
import './regular/file-word'
import './regular/file'
import './regular/flag'
import './regular/flushed'
import './regular/folder-open'
import './regular/folder'
import './regular/frown-open'
import './regular/frown'
import './regular/futbol'
import './regular/gem'
import './regular/grimace'
import './regular/grin-alt'
import './regular/grin-beam-sweat'
import './regular/grin-beam'
import './regular/grin-hearts'
import './regular/grin-squint-tears'
import './regular/grin-squint'
import './regular/grin-stars'
import './regular/grin-tears'
import './regular/grin-tongue-squint'
import './regular/grin-tongue-wink'
import './regular/grin-tongue'
import './regular/grin-wink'
import './regular/grin'
import './regular/hand-lizard'
import './regular/hand-paper'
import './regular/hand-peace'
import './regular/hand-point-down'
import './regular/hand-point-left'
import './regular/hand-point-right'
import './regular/hand-point-up'
import './regular/hand-pointer'
import './regular/hand-rock'
import './regular/hand-scissors'
import './regular/hand-spock'
import './regular/handshake'
import './regular/hdd'
import './regular/heart'
import './regular/hospital'
import './regular/hourglass'
import './regular/id-badge'
import './regular/id-card'
import './regular/image'
import './regular/images'
import './regular/keyboard'
import './regular/kiss-beam'
import './regular/kiss-wink-heart'
import './regular/kiss'
import './regular/laugh-beam'
import './regular/laugh-squint'
import './regular/laugh-wink'
import './regular/laugh'
import './regular/lemon'
import './regular/life-ring'
import './regular/lightbulb'
import './regular/list-alt'
import './regular/map'
import './regular/meh-blank'
import './regular/meh-rolling-eyes'
import './regular/meh'
import './regular/minus-square'
import './regular/money-bill-alt'
import './regular/moon'
import './regular/newspaper'
import './regular/object-group'
import './regular/object-ungroup'
import './regular/paper-plane'
import './regular/pause-circle'
import './regular/play-circle'
import './regular/plus-square'
import './regular/question-circle'
import './regular/registered'
import './regular/sad-cry'
import './regular/sad-tear'
import './regular/save'
import './regular/share-square'
import './regular/smile-beam'
import './regular/smile-wink'
import './regular/smile'
import './regular/snowflake'
import './regular/square'
import './regular/star-half'
import './regular/star'
import './regular/sticky-note'
import './regular/stop-circle'
import './regular/sun'
import './regular/surprise'
import './regular/thumbs-down'
import './regular/thumbs-up'
import './regular/times-circle'
import './regular/tired'
import './regular/trash-alt'
import './regular/user-circle'
import './regular/user'
import './regular/window-close'
import './regular/window-maximize'
import './regular/window-minimize'
import './regular/window-restore'
import './brands/500px'
import './brands/accessible-icon'
import './brands/accusoft'
import './brands/acquisitions-incorporated'
import './brands/adn'
import './brands/adobe'
import './brands/adversal'
import './brands/affiliatetheme'
import './brands/algolia'
import './brands/alipay'
import './brands/amazon-pay'
import './brands/amazon'
import './brands/amilia'
import './brands/android'
import './brands/angellist'
import './brands/angrycreative'
import './brands/angular'
import './brands/app-store-ios'
import './brands/app-store'
import './brands/apper'
import './brands/apple-pay'
import './brands/apple'
import './brands/artstation'
import './brands/asymmetrik'
import './brands/atlassian'
import './brands/audible'
import './brands/autoprefixer'
import './brands/avianex'
import './brands/aviato'
import './brands/aws'
import './brands/bandcamp'
import './brands/behance-square'
import './brands/behance'
import './brands/bimobject'
import './brands/bitbucket'
import './brands/bitcoin'
import './brands/bity'
import './brands/black-tie'
import './brands/blackberry'
import './brands/blogger-b'
import './brands/blogger'
import './brands/bluetooth-b'
import './brands/bluetooth'
import './brands/btc'
import './brands/buromobelexperte'
import './brands/buysellads'
import './brands/canadian-maple-leaf'
import './brands/cc-amazon-pay'
import './brands/cc-amex'
import './brands/cc-apple-pay'
import './brands/cc-diners-club'
import './brands/cc-discover'
import './brands/cc-jcb'
import './brands/cc-mastercard'
import './brands/cc-paypal'
import './brands/cc-stripe'
import './brands/cc-visa'
import './brands/centercode'
import './brands/centos'
import './brands/chrome'
import './brands/cloudscale'
import './brands/cloudsmith'
import './brands/cloudversify'
import './brands/codepen'
import './brands/codiepie'
import './brands/confluence'
import './brands/connectdevelop'
import './brands/contao'
import './brands/cpanel'
import './brands/creative-commons-by'
import './brands/creative-commons-nc-eu'
import './brands/creative-commons-nc-jp'
import './brands/creative-commons-nc'
import './brands/creative-commons-nd'
import './brands/creative-commons-pd-alt'
import './brands/creative-commons-pd'
import './brands/creative-commons-remix'
import './brands/creative-commons-sa'
import './brands/creative-commons-sampling-plus'
import './brands/creative-commons-sampling'
import './brands/creative-commons-share'
import './brands/creative-commons-zero'
import './brands/creative-commons'
import './brands/critical-role'
import './brands/css3-alt'
import './brands/css3'
import './brands/cuttlefish'
import './brands/d-and-d-beyond'
import './brands/d-and-d'
import './brands/dashcube'
import './brands/delicious'
import './brands/deploydog'
import './brands/deskpro'
import './brands/dev'
import './brands/deviantart'
import './brands/dhl'
import './brands/diaspora'
import './brands/digg'
import './brands/digital-ocean'
import './brands/discord'
import './brands/discourse'
import './brands/dochub'
import './brands/docker'
import './brands/draft2digital'
import './brands/dribbble-square'
import './brands/dribbble'
import './brands/dropbox'
import './brands/drupal'
import './brands/dyalog'
import './brands/earlybirds'
import './brands/ebay'
import './brands/edge'
import './brands/elementor'
import './brands/ello'
import './brands/ember'
import './brands/empire'
import './brands/envira'
import './brands/erlang'
import './brands/ethereum'
import './brands/etsy'
import './brands/expeditedssl'
import './brands/facebook-f'
import './brands/facebook-messenger'
import './brands/facebook-square'
import './brands/facebook'
import './brands/fantasy-flight-games'
import './brands/fedex'
import './brands/fedora'
import './brands/figma'
import './brands/firefox'
import './brands/first-order-alt'
import './brands/first-order'
import './brands/firstdraft'
import './brands/flickr'
import './brands/flipboard'
import './brands/fly'
import './brands/font-awesome-alt'
import './brands/font-awesome-flag'
import './brands/font-awesome'
import './brands/fonticons-fi'
import './brands/fonticons'
import './brands/fort-awesome-alt'
import './brands/fort-awesome'
import './brands/forumbee'
import './brands/foursquare'
import './brands/free-code-camp'
import './brands/freebsd'
import './brands/fulcrum'
import './brands/galactic-republic'
import './brands/galactic-senate'
import './brands/get-pocket'
import './brands/gg-circle'
import './brands/gg'
import './brands/git-square'
import './brands/git'
import './brands/github-alt'
import './brands/github-square'
import './brands/github'
import './brands/gitkraken'
import './brands/gitlab'
import './brands/gitter'
import './brands/glide-g'
import './brands/glide'
import './brands/gofore'
import './brands/goodreads-g'
import './brands/goodreads'
import './brands/google-drive'
import './brands/google-play'
import './brands/google-plus-g'
import './brands/google-plus-square'
import './brands/google-plus'
import './brands/google-wallet'
import './brands/google'
import './brands/gratipay'
import './brands/grav'
import './brands/gripfire'
import './brands/grunt'
import './brands/gulp'
import './brands/hacker-news-square'
import './brands/hacker-news'
import './brands/hackerrank'
import './brands/hips'
import './brands/hire-a-helper'
import './brands/hooli'
import './brands/hornbill'
import './brands/hotjar'
import './brands/houzz'
import './brands/html5'
import './brands/hubspot'
import './brands/imdb'
import './brands/instagram'
import './brands/intercom'
import './brands/internet-explorer'
import './brands/invision'
import './brands/ioxhost'
import './brands/itunes-note'
import './brands/itunes'
import './brands/java'
import './brands/jedi-order'
import './brands/jenkins'
import './brands/jira'
import './brands/joget'
import './brands/joomla'
import './brands/js-square'
import './brands/js'
import './brands/jsfiddle'
import './brands/kaggle'
import './brands/keybase'
import './brands/keycdn'
import './brands/kickstarter-k'
import './brands/kickstarter'
import './brands/korvue'
import './brands/laravel'
import './brands/lastfm-square'
import './brands/lastfm'
import './brands/leanpub'
import './brands/less'
import './brands/line'
import './brands/linkedin-in'
import './brands/linkedin'
import './brands/linode'
import './brands/linux'
import './brands/lyft'
import './brands/magento'
import './brands/mailchimp'
import './brands/mandalorian'
import './brands/markdown'
import './brands/mastodon'
import './brands/maxcdn'
import './brands/medapps'
import './brands/medium-m'
import './brands/medium'
import './brands/medrt'
import './brands/meetup'
import './brands/megaport'
import './brands/mendeley'
import './brands/microsoft'
import './brands/mix'
import './brands/mixcloud'
import './brands/mizuni'
import './brands/modx'
import './brands/monero'
import './brands/napster'
import './brands/neos'
import './brands/nimblr'
import './brands/nintendo-switch'
import './brands/node-js'
import './brands/node'
import './brands/npm'
import './brands/ns8'
import './brands/nutritionix'
import './brands/odnoklassniki-square'
import './brands/odnoklassniki'
import './brands/old-republic'
import './brands/opencart'
import './brands/openid'
import './brands/opera'
import './brands/optin-monster'
import './brands/osi'
import './brands/page4'
import './brands/pagelines'
import './brands/palfed'
import './brands/patreon'
import './brands/paypal'
import './brands/penny-arcade'
import './brands/periscope'
import './brands/phabricator'
import './brands/phoenix-framework'
import './brands/phoenix-squadron'
import './brands/php'
import './brands/pied-piper-alt'
import './brands/pied-piper-hat'
import './brands/pied-piper-pp'
import './brands/pied-piper'
import './brands/pinterest-p'
import './brands/pinterest-square'
import './brands/pinterest'
import './brands/playstation'
import './brands/product-hunt'
import './brands/pushed'
import './brands/python'
import './brands/qq'
import './brands/quinscape'
import './brands/quora'
import './brands/r-project'
import './brands/raspberry-pi'
import './brands/ravelry'
import './brands/react'
import './brands/reacteurope'
import './brands/readme'
import './brands/rebel'
import './brands/red-river'
import './brands/reddit-alien'
import './brands/reddit-square'
import './brands/reddit'
import './brands/redhat'
import './brands/renren'
import './brands/replyd'
import './brands/researchgate'
import './brands/resolving'
import './brands/rev'
import './brands/rocketchat'
import './brands/rockrms'
import './brands/safari'
import './brands/sass'
import './brands/schlix'
import './brands/scribd'
import './brands/searchengin'
import './brands/sellcast'
import './brands/sellsy'
import './brands/servicestack'
import './brands/shirtsinbulk'
import './brands/shopware'
import './brands/simplybuilt'
import './brands/sistrix'
import './brands/sith'
import './brands/sketch'
import './brands/skyatlas'
import './brands/skype'
import './brands/slack-hash'
import './brands/slack'
import './brands/slideshare'
import './brands/snapchat-ghost'
import './brands/snapchat-square'
import './brands/snapchat'
import './brands/soundcloud'
import './brands/sourcetree'
import './brands/speakap'
import './brands/spotify'
import './brands/squarespace'
import './brands/stack-exchange'
import './brands/stack-overflow'
import './brands/staylinked'
import './brands/steam-square'
import './brands/steam-symbol'
import './brands/steam'
import './brands/sticker-mule'
import './brands/strava'
import './brands/stripe-s'
import './brands/stripe'
import './brands/studiovinari'
import './brands/stumbleupon-circle'
import './brands/stumbleupon'
import './brands/superpowers'
import './brands/supple'
import './brands/suse'
import './brands/teamspeak'
import './brands/telegram-plane'
import './brands/telegram'
import './brands/tencent-weibo'
import './brands/the-red-yeti'
import './brands/themeco'
import './brands/themeisle'
import './brands/think-peaks'
import './brands/trade-federation'
import './brands/trello'
import './brands/tripadvisor'
import './brands/tumblr-square'
import './brands/tumblr'
import './brands/twitch'
import './brands/twitter-square'
import './brands/twitter'
import './brands/typo3'
import './brands/uber'
import './brands/ubuntu'
import './brands/uikit'
import './brands/uniregistry'
import './brands/untappd'
import './brands/ups'
import './brands/usb'
import './brands/usps'
import './brands/ussunnah'
import './brands/vaadin'
import './brands/viacoin'
import './brands/viadeo-square'
import './brands/viadeo'
import './brands/viber'
import './brands/vimeo-square'
import './brands/vimeo-v'
import './brands/vimeo'
import './brands/vine'
import './brands/vk'
import './brands/vnv'
import './brands/vuejs'
import './brands/weebly'
import './brands/weibo'
import './brands/weixin'
import './brands/whatsapp-square'
import './brands/whatsapp'
import './brands/whmcs'
import './brands/wikipedia-w'
import './brands/windows'
import './brands/wix'
import './brands/wizards-of-the-coast'
import './brands/wolf-pack-battalion'
import './brands/wordpress-simple'
import './brands/wordpress'
import './brands/wpbeginner'
import './brands/wpexplorer'
import './brands/wpforms'
import './brands/wpressr'
import './brands/xbox'
import './brands/xing-square'
import './brands/xing'
import './brands/y-combinator'
import './brands/yahoo'
import './brands/yandex-international'
import './brands/yandex'
import './brands/yarn'
import './brands/yelp'
import './brands/yoast'
import './brands/youtube-square'
import './brands/youtube'
import './brands/zhihu'
import './ad'
import './address-book'
import './address-card'
import './adjust'
import './air-freshener'
import './align-center'
import './align-justify'
import './align-left'
import './align-right'
import './allergies'
import './ambulance'
import './american-sign-language-interpreting'
import './anchor'
import './angle-double-down'
import './angle-double-left'
import './angle-double-right'
import './angle-double-up'
import './angle-down'
import './angle-left'
import './angle-right'
import './angle-up'
import './angry'
import './ankh'
import './apple-alt'
import './archive'
import './archway'
import './arrow-alt-circle-down'
import './arrow-alt-circle-left'
import './arrow-alt-circle-right'
import './arrow-alt-circle-up'
import './arrow-circle-down'
import './arrow-circle-left'
import './arrow-circle-right'
import './arrow-circle-up'
import './arrow-down'
import './arrow-left'
import './arrow-right'
import './arrow-up'
import './arrows-alt-h'
import './arrows-alt-v'
import './arrows-alt'
import './assistive-listening-systems'
import './asterisk'
import './at'
import './atlas'
import './atom'
import './audio-description'
import './award'
import './baby-carriage'
import './baby'
import './backspace'
import './backward'
import './balance-scale'
import './ban'
import './band-aid'
import './barcode'
import './bars'
import './baseball-ball'
import './basketball-ball'
import './bath'
import './battery-empty'
import './battery-full'
import './battery-half'
import './battery-quarter'
import './battery-three-quarters'
import './bed'
import './beer'
import './bell-slash'
import './bell'
import './bezier-curve'
import './bible'
import './bicycle'
import './binoculars'
import './biohazard'
import './birthday-cake'
import './blender-phone'
import './blender'
import './blind'
import './blog'
import './bold'
import './bolt'
import './bomb'
import './bone'
import './bong'
import './book-dead'
import './book-open'
import './book-reader'
import './book'
import './bookmark'
import './bowling-ball'
import './box-open'
import './box'
import './boxes'
import './braille'
import './brain'
import './briefcase-medical'
import './briefcase'
import './broadcast-tower'
import './broom'
import './brush'
import './bug'
import './building'
import './bullhorn'
import './bullseye'
import './burn'
import './bus-alt'
import './bus'
import './business-time'
import './calculator'
import './calendar-alt'
import './calendar-check'
import './calendar-day'
import './calendar-minus'
import './calendar-plus'
import './calendar-times'
import './calendar-week'
import './calendar'
import './camera-retro'
import './camera'
import './campground'
import './candy-cane'
import './cannabis'
import './capsules'
import './car-alt'
import './car-battery'
import './car-crash'
import './car-side'
import './car'
import './caret-down'
import './caret-left'
import './caret-right'
import './caret-square-down'
import './caret-square-left'
import './caret-square-right'
import './caret-square-up'
import './caret-up'
import './carrot'
import './cart-arrow-down'
import './cart-plus'
import './cash-register'
import './cat'
import './certificate'
import './chair'
import './chalkboard-teacher'
import './chalkboard'
import './charging-station'
import './chart-area'
import './chart-bar'
import './chart-line'
import './chart-pie'
import './check-circle'
import './check-double'
import './check-square'
import './check'
import './chess-bishop'
import './chess-board'
import './chess-king'
import './chess-knight'
import './chess-pawn'
import './chess-queen'
import './chess-rook'
import './chess'
import './chevron-circle-down'
import './chevron-circle-left'
import './chevron-circle-right'
import './chevron-circle-up'
import './chevron-down'
import './chevron-left'
import './chevron-right'
import './chevron-up'
import './child'
import './church'
import './circle-notch'
import './circle'
import './city'
import './clipboard-check'
import './clipboard-list'
import './clipboard'
import './clock'
import './clone'
import './closed-captioning'
import './cloud-download-alt'
import './cloud-meatball'
import './cloud-moon-rain'
import './cloud-moon'
import './cloud-rain'
import './cloud-showers-heavy'
import './cloud-sun-rain'
import './cloud-sun'
import './cloud-upload-alt'
import './cloud'
import './cocktail'
import './code-branch'
import './code'
import './coffee'
import './cog'
import './cogs'
import './coins'
import './columns'
import './comment-alt'
import './comment-dollar'
import './comment-dots'
import './comment-slash'
import './comment'
import './comments-dollar'
import './comments'
import './compact-disc'
import './compass'
import './compress-arrows-alt'
import './compress'
import './concierge-bell'
import './cookie-bite'
import './cookie'
import './copy'
import './copyright'
import './couch'
import './credit-card'
import './crop-alt'
import './crop'
import './cross'
import './crosshairs'
import './crow'
import './crown'
import './cube'
import './cubes'
import './cut'
import './database'
import './deaf'
import './democrat'
import './desktop'
import './dharmachakra'
import './diagnoses'
import './dice-d20'
import './dice-d6'
import './dice-five'
import './dice-four'
import './dice-one'
import './dice-six'
import './dice-three'
import './dice-two'
import './dice'
import './digital-tachograph'
import './directions'
import './divide'
import './dizzy'
import './dna'
import './dog'
import './dollar-sign'
import './dolly-flatbed'
import './dolly'
import './donate'
import './door-closed'
import './door-open'
import './dot-circle'
import './dove'
import './download'
import './drafting-compass'
import './dragon'
import './draw-polygon'
import './drum-steelpan'
import './drum'
import './drumstick-bite'
import './dumbbell'
import './dumpster-fire'
import './dumpster'
import './dungeon'
import './edit'
import './eject'
import './ellipsis-h'
import './ellipsis-v'
import './envelope-open-text'
import './envelope-open'
import './envelope-square'
import './envelope'
import './equals'
import './eraser'
import './ethernet'
import './euro-sign'
import './exchange-alt'
import './exclamation-circle'
import './exclamation-triangle'
import './exclamation'
import './expand-arrows-alt'
import './expand'
import './external-link-alt'
import './external-link-square-alt'
import './eye-dropper'
import './eye-slash'
import './eye'
import './fast-backward'
import './fast-forward'
import './fax'
import './feather-alt'
import './feather'
import './female'
import './fighter-jet'
import './file-alt'
import './file-archive'
import './file-audio'
import './file-code'
import './file-contract'
import './file-csv'
import './file-download'
import './file-excel'
import './file-export'
import './file-image'
import './file-import'
import './file-invoice-dollar'
import './file-invoice'
import './file-medical-alt'
import './file-medical'
import './file-pdf'
import './file-powerpoint'
import './file-prescription'
import './file-signature'
import './file-upload'
import './file-video'
import './file-word'
import './file'
import './fill-drip'
import './fill'
import './film'
import './filter'
import './fingerprint'
import './fire-alt'
import './fire-extinguisher'
import './fire'
import './first-aid'
import './fish'
import './fist-raised'
import './flag-checkered'
import './flag-usa'
import './flag'
import './flask'
import './flushed'
import './folder-minus'
import './folder-open'
import './folder-plus'
import './folder'
import './font'
import './football-ball'
import './forward'
import './frog'
import './frown-open'
import './frown'
import './funnel-dollar'
import './futbol'
import './gamepad'
import './gas-pump'
import './gavel'
import './gem'
import './genderless'
import './ghost'
import './gift'
import './gifts'
import './glass-cheers'
import './glass-martini-alt'
import './glass-martini'
import './glass-whiskey'
import './glasses'
import './globe-africa'
import './globe-americas'
import './globe-asia'
import './globe-europe'
import './globe'
import './golf-ball'
import './gopuram'
import './graduation-cap'
import './greater-than-equal'
import './greater-than'
import './grimace'
import './grin-alt'
import './grin-beam-sweat'
import './grin-beam'
import './grin-hearts'
import './grin-squint-tears'
import './grin-squint'
import './grin-stars'
import './grin-tears'
import './grin-tongue-squint'
import './grin-tongue-wink'
import './grin-tongue'
import './grin-wink'
import './grin'
import './grip-horizontal'
import './grip-lines-vertical'
import './grip-lines'
import './grip-vertical'
import './guitar'
import './h-square'
import './hammer'
import './hamsa'
import './hand-holding-heart'
import './hand-holding-usd'
import './hand-holding'
import './hand-lizard'
import './hand-paper'
import './hand-peace'
import './hand-point-down'
import './hand-point-left'
import './hand-point-right'
import './hand-point-up'
import './hand-pointer'
import './hand-rock'
import './hand-scissors'
import './hand-spock'
import './hands-helping'
import './hands'
import './handshake'
import './hanukiah'
import './hashtag'
import './hat-wizard'
import './haykal'
import './hdd'
import './heading'
import './headphones-alt'
import './headphones'
import './headset'
import './heart-broken'
import './heart'
import './heartbeat'
import './helicopter'
import './highlighter'
import './hiking'
import './hippo'
import './history'
import './hockey-puck'
import './holly-berry'
import './home'
import './horse-head'
import './horse'
import './hospital-alt'
import './hospital-symbol'
import './hospital'
import './hot-tub'
import './hotel'
import './hourglass-end'
import './hourglass-half'
import './hourglass-start'
import './hourglass'
import './house-damage'
import './hryvnia'
import './i-cursor'
import './icicles'
import './id-badge'
import './id-card-alt'
import './id-card'
import './igloo'
import './image'
import './images'
import './inbox'
import './indent'
import './industry'
import './infinity'
import './info-circle'
import './info'
import './italic'
import './jedi'
import './joint'
import './journal-whills'
import './kaaba'
import './key'
import './keyboard'
import './khanda'
import './kiss-beam'
import './kiss-wink-heart'
import './kiss'
import './kiwi-bird'
import './landmark'
import './language'
import './laptop-code'
import './laptop'
import './laugh-beam'
import './laugh-squint'
import './laugh-wink'
import './laugh'
import './layer-group'
import './leaf'
import './lemon'
import './less-than-equal'
import './less-than'
import './level-down-alt'
import './level-up-alt'
import './life-ring'
import './lightbulb'
import './link'
import './lira-sign'
import './list-alt'
import './list-ol'
import './list-ul'
import './list'
import './location-arrow'
import './lock-open'
import './lock'
import './long-arrow-alt-down'
import './long-arrow-alt-left'
import './long-arrow-alt-right'
import './long-arrow-alt-up'
import './low-vision'
import './luggage-cart'
import './magic'
import './magnet'
import './mail-bulk'
import './male'
import './map-marked-alt'
import './map-marked'
import './map-marker-alt'
import './map-marker'
import './map-pin'
import './map-signs'
import './map'
import './marker'
import './mars-double'
import './mars-stroke-h'
import './mars-stroke-v'
import './mars-stroke'
import './mars'
import './mask'
import './medal'
import './medkit'
import './meh-blank'
import './meh-rolling-eyes'
import './meh'
import './memory'
import './menorah'
import './mercury'
import './meteor'
import './microchip'
import './microphone-alt-slash'
import './microphone-alt'
import './microphone-slash'
import './microphone'
import './microscope'
import './minus-circle'
import './minus-square'
import './minus'
import './mitten'
import './mobile-alt'
import './mobile'
import './money-bill-alt'
import './money-bill-wave-alt'
import './money-bill-wave'
import './money-bill'
import './money-check-alt'
import './money-check'
import './monument'
import './moon'
import './mortar-pestle'
import './mosque'
import './motorcycle'
import './mountain'
import './mouse-pointer'
import './mug-hot'
import './music'
import './network-wired'
import './neuter'
import './newspaper'
import './not-equal'
import './notes-medical'
import './object-group'
import './object-ungroup'
import './oil-can'
import './om'
import './otter'
import './outdent'
import './paint-brush'
import './paint-roller'
import './palette'
import './pallet'
import './paper-plane'
import './paperclip'
import './parachute-box'
import './paragraph'
import './parking'
import './passport'
import './pastafarianism'
import './paste'
import './pause-circle'
import './pause'
import './paw'
import './peace'
import './pen-alt'
import './pen-fancy'
import './pen-nib'
import './pen-square'
import './pen'
import './pencil-alt'
import './pencil-ruler'
import './people-carry'
import './percent'
import './percentage'
import './person-booth'
import './phone-slash'
import './phone-square'
import './phone-volume'
import './phone'
import './piggy-bank'
import './pills'
import './place-of-worship'
import './plane-arrival'
import './plane-departure'
import './plane'
import './play-circle'
import './play'
import './plug'
import './plus-circle'
import './plus-square'
import './plus'
import './podcast'
import './poll-h'
import './poll'
import './poo-storm'
import './poo'
import './poop'
import './portrait'
import './pound-sign'
import './power-off'
import './pray'
import './praying-hands'
import './prescription-bottle-alt'
import './prescription-bottle'
import './prescription'
import './print'
import './procedures'
import './project-diagram'
import './puzzle-piece'
import './qrcode'
import './question-circle'
import './question'
import './quidditch'
import './quote-left'
import './quote-right'
import './quran'
import './radiation-alt'
import './radiation'
import './rainbow'
import './random'
import './receipt'
import './recycle'
import './redo-alt'
import './redo'
import './registered'
import './reply-all'
import './reply'
import './republican'
import './restroom'
import './retweet'
import './ribbon'
import './ring'
import './road'
import './robot'
import './rocket'
import './route'
import './rss-square'
import './rss'
import './ruble-sign'
import './ruler-combined'
import './ruler-horizontal'
import './ruler-vertical'
import './ruler'
import './running'
import './rupee-sign'
import './sad-cry'
import './sad-tear'
import './satellite-dish'
import './satellite'
import './save'
import './school'
import './screwdriver'
import './scroll'
import './sd-card'
import './search-dollar'
import './search-location'
import './search-minus'
import './search-plus'
import './search'
import './seedling'
import './server'
import './shapes'
import './share-alt-square'
import './share-alt'
import './share-square'
import './share'
import './shekel-sign'
import './shield-alt'
import './ship'
import './shipping-fast'
import './shoe-prints'
import './shopping-bag'
import './shopping-basket'
import './shopping-cart'
import './shower'
import './shuttle-van'
import './sign-in-alt'
import './sign-language'
import './sign-out-alt'
import './sign'
import './signal'
import './signature'
import './sim-card'
import './sitemap'
import './skating'
import './skiing-nordic'
import './skiing'
import './skull-crossbones'
import './skull'
import './slash'
import './sleigh'
import './sliders-h'
import './smile-beam'
import './smile-wink'
import './smile'
import './smog'
import './smoking-ban'
import './smoking'
import './sms'
import './snowboarding'
import './snowflake'
import './snowman'
import './snowplow'
import './socks'
import './solar-panel'
import './sort-alpha-down'
import './sort-alpha-up'
import './sort-amount-down'
import './sort-amount-up'
import './sort-down'
import './sort-numeric-down'
import './sort-numeric-up'
import './sort-up'
import './sort'
import './spa'
import './space-shuttle'
import './spider'
import './spinner'
import './splotch'
import './spray-can'
import './square-full'
import './square-root-alt'
import './square'
import './stamp'
import './star-and-crescent'
import './star-half-alt'
import './star-half'
import './star-of-david'
import './star-of-life'
import './star'
import './step-backward'
import './step-forward'
import './stethoscope'
import './sticky-note'
import './stop-circle'
import './stop'
import './stopwatch'
import './store-alt'
import './store'
import './stream'
import './street-view'
import './strikethrough'
import './stroopwafel'
import './subscript'
import './subway'
import './suitcase-rolling'
import './suitcase'
import './sun'
import './superscript'
import './surprise'
import './swatchbook'
import './swimmer'
import './swimming-pool'
import './synagogue'
import './sync-alt'
import './sync'
import './syringe'
import './table-tennis'
import './table'
import './tablet-alt'
import './tablet'
import './tablets'
import './tachometer-alt'
import './tag'
import './tags'
import './tape'
import './tasks'
import './taxi'
import './teeth-open'
import './teeth'
import './temperature-high'
import './temperature-low'
import './tenge'
import './terminal'
import './text-height'
import './text-width'
import './th-large'
import './th-list'
import './th'
import './theater-masks'
import './thermometer-empty'
import './thermometer-full'
import './thermometer-half'
import './thermometer-quarter'
import './thermometer-three-quarters'
import './thermometer'
import './thumbs-down'
import './thumbs-up'
import './thumbtack'
import './ticket-alt'
import './times-circle'
import './times'
import './tint-slash'
import './tint'
import './tired'
import './toggle-off'
import './toggle-on'
import './toilet-paper'
import './toilet'
import './toolbox'
import './tools'
import './tooth'
import './torah'
import './torii-gate'
import './tractor'
import './trademark'
import './traffic-light'
import './train'
import './tram'
import './transgender-alt'
import './transgender'
import './trash-alt'
import './trash'
import './tree'
import './trophy'
import './truck-loading'
import './truck-monster'
import './truck-moving'
import './truck-pickup'
import './truck'
import './tshirt'
import './tty'
import './tv'
import './umbrella-beach'
import './umbrella'
import './underline'
import './undo-alt'
import './undo'
import './universal-access'
import './university'
import './unlink'
import './unlock-alt'
import './unlock'
import './upload'
import './user-alt-slash'
import './user-alt'
import './user-astronaut'
import './user-check'
import './user-circle'
import './user-clock'
import './user-cog'
import './user-edit'
import './user-friends'
import './user-graduate'
import './user-injured'
import './user-lock'
import './user-md'
import './user-minus'
import './user-ninja'
import './user-plus'
import './user-secret'
import './user-shield'
import './user-slash'
import './user-tag'
import './user-tie'
import './user-times'
import './user'
import './users-cog'
import './users'
import './utensil-spoon'
import './utensils'
import './vector-square'
import './venus-double'
import './venus-mars'
import './venus'
import './vial'
import './vials'
import './video-slash'
import './video'
import './vihara'
import './volleyball-ball'
import './volume-down'
import './volume-mute'
import './volume-off'
import './volume-up'
import './vote-yea'
import './vr-cardboard'
import './walking'
import './wallet'
import './warehouse'
import './water'
import './weight-hanging'
import './weight'
import './wheelchair'
import './wifi'
import './wind'
import './window-close'
import './window-maximize'
import './window-minimize'
import './window-restore'
import './wine-bottle'
import './wine-glass-alt'
import './wine-glass'
import './won-sign'
import './wrench'
import './x-ray'
import './yen-sign'
import './yin-yang'



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/index.js
// module id = D/PP
// module chunks = 144